import { render, staticRenderFns } from "./printInfo.vue?vue&type=template&id=fc897792&scoped=true&"
import script from "./printInfo.vue?vue&type=script&lang=js&"
export * from "./printInfo.vue?vue&type=script&lang=js&"
import style0 from "./printInfo.vue?vue&type=style&index=0&id=fc897792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc897792",
  null
  
)

export default component.exports